import { render, staticRenderFns } from "./CandidateDetailCard.vue?vue&type=template&id=4a8552bc&scoped=true&"
import script from "./CandidateDetailCard.vue?vue&type=script&lang=ts&"
export * from "./CandidateDetailCard.vue?vue&type=script&lang=ts&"
import style0 from "./CandidateDetailCard.vue?vue&type=style&index=0&id=4a8552bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8552bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VBtn,VChip,VIcon,VImg,VSkeletonLoader,VTooltip})
